import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  Inject,
  NgZone,
  Component,
  OnDestroy,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ChangeDetectionStrategy,
} from '@angular/core';

import { ISnPlayer } from '../../interfaces';

@Component({
  selector: 'sn-player-hls-time-control',
  templateUrl: './player-hls-time.control.html',
  styleUrls: ['./player-hls-time.control.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'sn-player__hls-time-control',
  },
})
export class SnPlayerHlsTimeControl implements AfterViewInit, OnDestroy {
  @ViewChild('hlsTime')
  private readonly _hlsTimeRef: ElementRef<HTMLElement>;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _ngZone: NgZone,
    @Inject('SN_PLAYER') private readonly _player: ISnPlayer,
  ) {}

  public ngAfterViewInit(): void {
    this._ngZone.runOutsideAngular(() => {
      this._initSubscription();
    });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  private _initSubscription(): void {
    this._player.currentTime$.pipe(takeUntil(this._destroy$)).subscribe(() => {
      this._updateHlsTime();
    });
  }

  private _updateHlsTime(): void {
    if (this._hlsTimeRef?.nativeElement && this._player.actualTime) {
      const hlsTimestamp = new Date(this._player.actualTime);
      this._hlsTimeRef.nativeElement.textContent = hlsTimestamp.toLocaleString();
    } else if (this._hlsTimeRef?.nativeElement) {
      this._hlsTimeRef.nativeElement.textContent = ''; // Show empty if no actual time is available.
    }
  }
}
